// pipe to $enum
import { Enum } from 'ivux-enum-manager/src/index'
export default Enum